const isDev = process.env.NODE_ENV !== "production";

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};
